import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'
import { merchantTheme } from 'theme'
import NeedsAttentionRow from './NeedsAttentionRow'
import useNeedsAttention from './useNeedsAttention'

const t = buildTranslate('home')

const NeedsAttention = () => {
  const { showSection, rows } = useNeedsAttention()
  const [css] = useStyletron()
  if (!showSection) return null

  return (
    <Row className="mb-xxl">
      <Col>
        {/* h2 = real heading for SR heading-nav (sibling Metrics uses Header2);
            .small-caps CSS uppercases the sentence-case locale value. */}
        <Text.SmallCaps3 tag="h2" bold color="grey70" className="mb-s">
          {t('needs_attention.heading')}
        </Text.SmallCaps3>
        {/* Bordered list container; each row owns its own horizontal padding
            (mirrors SelectedLocationsList.tsx's list/row split). */}
        <div
          className={css({
            border: `1px solid ${merchantTheme.colors.grey20}`,
            borderRadius: '4px',
            backgroundColor: merchantTheme.colors.white,
          })}
        >
          {/* Single row today, so no inter-row divider. Re-adding a second row
              means restoring a divider between them (see useNeedsAttention). */}
          {rows.map(({ id, ...rowProps }) => (
            <NeedsAttentionRow key={id} {...rowProps} />
          ))}
        </div>
      </Col>
    </Row>
  )
}

export default NeedsAttention
